import React from "react";
import About from "@/components/About";
import Notify from "@/components/Notify";

const StoryPage = () => (
  <div className="paper-overlay" data-testid="story-page">
    <About />
    <Notify />
  </div>
);

export default StoryPage;
